import { render, staticRenderFns } from "./IframeModule.vue?vue&type=template&id=ae49955a&scoped=true"
import script from "./IframeModule.vue?vue&type=script&lang=js"
export * from "./IframeModule.vue?vue&type=script&lang=js"
import style0 from "./IframeModule.vue?vue&type=style&index=0&id=ae49955a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae49955a",
  null
  
)

export default component.exports